module.exports = __webpack_public_path__ + "img/emoji_106.58355443.png";